module.exports = __webpack_public_path__ + "static/img/s164.51940148.png";